import { formatDate } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HttpService } from "src/app/shared/http.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.scss"],
})
export class AboutComponent implements OnInit {
  yearNow = "";
  appInfo: any = {};
  data: any = {};
  env = "";
  constructor(
    public activeModal: NgbActiveModal,
    private httpService: HttpService
  ) {
    this.yearNow = formatDate(new Date(), "yyyy", "en-US");
  }

  ngOnInit() {
    let that = this;
    that.appInfo = that.httpService.appInfo();
    that.env = environment.name;
  }
}
